module.exports = __webpack_public_path__ + "static/media/share-icon.f875cc97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/share-icon.png
// module id = 1896
// module chunks = 6